import Logger from "modules/logging/utils.js"

export default Logger
